import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface CheckoutSpinnerWidgetStyles {
    wrapper?: InjectableCss;
    modal?: InjectableCss;
    modalMessage?: TypographyPresentationProps;
}

export const checkoutSpinnerWidgetStyles: CheckoutSpinnerWidgetStyles = {
    // COPYING STYLES FROM CLASSIC
    wrapper: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            position: fixed;
            background: rgba(255, 255, 255, 0.7);
            z-index: 100;
            top: 0;
            left: 0;

            .checkout_loader {
                width: 600px;
                height: 200px;
                background: #fff;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.3);
                margin: auto;
                left: 50%;
                z-index: 10;
                position: fixed;
                top: 50%;
                transform: translate(-50%, -50%);

                @media all and (max-width: 768px) {
                    width: 325px;
                }
            }

            .checkout_spinner_container {
                height: 15px;
                width: 200px;
                display: flex;
                position: relative;

                .rect-doct {
                    width: 12px;
                    height: 12px;
                    background-color: #e82011;
                    animation: move 500ms linear 0ms infinite;
                    margin-right: 30px;

                    &:first-child {
                        position: absolute;
                        top: 0;
                        left: 0;
                        animation: grow 500ms linear 0ms infinite;
                    }

                    &:last-child {
                        position: absolute;
                        top: 0;
                        right: 0;
                        margin-right: 15px;
                        animation: grow 500ms linear 0s infinite reverse;
                    }

                    @keyframes grow {
                        from {
                            transform: scale(0, 0);
                            opacity: 0;
                        }

                        to {
                            transform: scale(1, 1);
                            opacity: 1;
                        }
                    }

                    @keyframes move {
                        from {
                            transform: translateX(0);
                        }

                        to {
                            transform: translateX(45px);
                        }
                    }
                }
            }
        `,
    },

    modalMessage: {
        variant: "h3",
        size: 24,
        css: css`
            text-align: center;
            margin-bottom: 20px;
        `,
    },
};

export const styles = checkoutSpinnerWidgetStyles;

export const CheckoutSpinner = () => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <div className="checkout_loader">
                <Typography {...styles.modalMessage} data-test-selector="checkoutSpinner" as="h2">
                    {siteMessage("Checkout_Spinner_Description")}
                </Typography>
                <div className="checkout_spinner_container">
                    <span className="rect-doct"></span>
                    <span className="rect-doct"></span>
                    <span className="rect-doct"></span>
                    <span className="rect-doct"></span>
                    <span className="rect-doct"></span>
                    <span className="rect-doct"></span>
                </div>
            </div>
        </StyledWrapper>
    );
};
